<template>
    <div>
        <v-container>
            <v-layout>
                <v-flex class="text-center">
                    <h2 class="titulo mb-12">CARRINHO DE COMPRAS</h2>
                </v-flex>
            </v-layout>
            <v-card elevation="3">
                <v-layout class="justify-center w-100 d-flex px-10 pb-4">
                    <v-flex xs12 class="w-100">
                        <v-row class="mt-2 mb-8 w-100 mx-auto">
                            <v-col cols="12" md="3"> </v-col>
                            <v-col cols="6" md="5" lg="3" class="mx-auto" align-self="center">
                                <ImagemBem v-if="pedido.bem.id_bem" :id-bem="pedido.bem.id_bem" />
                            </v-col>
                            <v-col cols="12" md="3">
                            </v-col>
                        </v-row>
                        <v-flex xs12 md6 class="pl-1">
                            <label class="mb-2">Nome do bem</label>
                            <p>{{ (pedido.bem.cd_bem ? pedido.bem.cd_bem : "") + " - " + pedido.bem.nome_bem }}</p>
                        </v-flex>
                        <v-row class="mt-6">
                            <v-col cols="12" sm="6" md="4" class="d-flex justify-md-start">
                                <div class="d-flex flex-column">
                                    <label class="pr-md-6">Grupo</label>
                                    <span class="codigo_grupo mt-3 mb-5">{{ trimZeros(pedido.bem.cd_grupo) ||
                                        trimZeros(pedido.cd_grupo) || "-" }}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" class="d-flex justify-md-center">
                                <div class="d-flex flex-column">
                                    <label class="pr-md-6">Valor do Bem</label>
                                    <span class="mt-2 mb-5">{{ pedido.bem.valor_bem || 0 | money }}</span>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" class="d-flex justify-md-end">
                                <div class="d-flex flex-column">
                                    <label>Prazo Contratado</label>
                                    <span class="mt-2 mb-5">{{ pedido.plano.prazo_comercializacao }}</span>
                                </div>
                            </v-col>
                        </v-row>
                    </v-flex>
                </v-layout>

                <v-divider></v-divider>
                <v-card-actions class="px-11 actions-background">
                    <v-row class="d-flex justify-space-between">
                        <div class="d-flex flex-column align-start">
                            <p class="mt-5 mb-0 quantidade_cotas-label">Quantidade de Cotas</p>
                            <div>
                                <Counter
                                        v-model="qtd_cotas"
                                        :max-value="limiteCotasComputed"
                                        :can-add="canAddCota"
                                        :can-remove="canRemoveCota"
                                        :limit-message="limiteCotasLimitMessageComputed"
                                />
                            </div>
                        </div>
                        <div class="d-flex flex-column align-end">
                            <p class="mt-5 mb-0 quantidade_cotas-label">Valor total</p>
                            <div class="mt-5">
                                <span class="mb-5 credito">{{ valorTotal | money }}</span>
                            </div>
                        </div>
                    </v-row>
                </v-card-actions>
            </v-card>
            <v-layout>
                <v-flex xs12 class="d-flex justify-space-between mt-8">
                    <v-tooltip top style="z-index: 1000;">
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn
                                        id="ButtonVoltar"
                                        :disabled="blockVoltarTela"
                                        block
                                        color="secondary"
                                        @click="prevPage"
                                        :text="!blockVoltarTela"
                                        style="margin-left: 0;"
                                >
                                    Voltar
                                </v-btn>
                            </div>
                        </template>
                        <span>Ação proibida por conter análise de crédito.</span>
                    </v-tooltip>
                    <div>
                        <span class="mr-2" v-if="dialogQuantidadeCotasAtivo">
                            Seu cliente pode comprar
                            <span style="color: green">{{ calcularLimiteQuantidadeCotasPodeComprar() || `${0} cotas` }}</span>
                            deste produto.
                        </span>
                        <v-btn v-if="!bloquearBotaoProsseguir"
                               id="ButtonContinuar"
                               color="primary"
                               class="ma-2"
                               @click="verificarPossiveisBloqueios"
                               :disabled="bloquearBotaoProsseguir"
                        >
                            PROSSEGUIR
                        </v-btn>
                        <v-tooltip left color="white" v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <span v-bind="attrs" v-on="on">
                                    <v-btn
                                            id="ButtonContinuar"
                                            color="primary"
                                            class="ma-2"
                                            disabled
                                    >
                                        PROSSEGUIR
                                    </v-btn>
                                </span>
                            </template>
                            <div class="warning-text">
                                {{ mensagemTooltipBotaoProsseguir }}
                            </div>
                        </v-tooltip>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <DialoginformativoLimiteCreditoPontoVendaExcedido
                :visivel="exibirDialogInformativoLimiteCreditoPontovendaExcedido"
                :limite-atual="limiteCreditoPontoVendaAtual"
                :limite-para-aumentar="limiteCreditoPontoVendaAumentar"
                @fecharInformativoLimiteCreditoPontoVendaExcedido="fecharInformativoLimiteCreditoPontoVendaExcedido"
                @prosseguirInformativoLimiteCreditoPontoVendaExcedido="prosseguirInformativoLimiteCreditoPontoVendaExcedido"
        />

        <DialogInformativoSaldoDevedorCliente
                :visivel="exibirDialogInformativoSaldoDevedorCliente"
                :saldo-atual="limiteSaldoDevedorClienteAtual"
                :saldo-para-aumentar="limiteSaldoDevedorClienteAumentar"
                :saldo-devedor-cliente="saldoDevedorCliente"
                :saldo-devedor-solicitavel="saldoDevedorSolicitavel"
                :limite-disponivel="limiteDisponivel"
                :nova-solicitacao-limite="novaSolicitacaoLimite"
                :valor-por-cota="valorPorCota"
                :quantidade-cotas="quantidadeCotas"
                :valor-total-proposta="valorTotalProposta"
                :saldo-devedor-futuro="saldoDevedorFuturo"
                @fecharInformativoSaldoDevedorCliente="fecharInformativoSaldoDevedorCliente"
                @fecharProsseguirInformativoLimiteCreditoPontoVendaExcedido="fecharProsseguirInformativoLimiteCreditoPontoVendaExcedido"
        />

        <DialogInformativoQuantidadeCotasDisponiveis
                :visivel="exibirDialogQuantidadeCotasDisponiveis"
                :cotas-ativas-grupo="cotasAtivasGrupo"
                :cotas-ativas-cliente="cotasAtivasCliente"
                @fecharInformativoQuantidadeCotasDisponiveis="fecharInformativoQuantidadeCotasDisponiveis"
        />
    </div>
</template>

<script>
  import { notification, trimZeros, unmask } from '@/plugins/helpers'
  import { pedido_default } from '../../../plugins/pedido_default'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import ImagemBem from '../../../components/bem/ImagemBem.vue'
  import Counter from '../../../components/common/Counter.vue'
  import { mapState } from 'vuex'
  import DialoginformativoLimiteCreditoPontoVendaExcedido from '@/dialogs/ponto-venda/DialogInformativoLimiteCreditoPontoVendaExcedido.vue'
  import DialogInformativoSaldoDevedorCliente from '@/dialogs/clientes/DialogInformativoSaldoDevedorCliente.vue'
  import DialogInformativoQuantidadeCotasDisponiveis from '@/dialogs/cotas/DialogInformativoQuantidadeCotasDisponiveis.vue'
  import { StatusPedido } from '@/plugins/constants'
  import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
  export default {
    name: 'Cotas',
    components: {
      ImagemBem,
      Counter,
      DialoginformativoLimiteCreditoPontoVendaExcedido,
      DialogInformativoSaldoDevedorCliente,
      DialogInformativoQuantidadeCotasDisponiveis
    },
    props: { value: Object },
    data: () => ({
      pedido: pedido_default,
      qtd_cotas: 1,
      limiteMaximoCotasGrupo: 1,
      errBuscarCotas: false,
      exibirDialogInformativoLimiteCreditoPontovendaExcedido: false,
      exibirDialogInformativoSaldoDevedorCliente: false,
      limiteCreditoPontoVendaAtual: '',
      limiteCreditoPontoVendaAumentar: '',
      limiteSaldoDevedorClienteAtual: '',
      limiteSaldoDevedorClienteAumentar: '',
      saldoDevedorCliente: '',
      exibirMensagemQuantidadeCotasPodeComprar: false,
      quantidadeCotasPodeComprar: 0,
      bloquearBotaoProsseguir: false,
      cotasAtivasGrupo: 0,
      cotasAtivasCliente: 0,
      exibirDialogQuantidadeCotasDisponiveis: false,
      mensagemTooltipBotaoProsseguir: '',
      dialogQuantidadeCotasAtivo: false,
      verificarQuantidadeCotas: true,
      quantidadeCotasPermitidasVenda: 0,
      limiteCreditoPontoVendaVerificado: false,
      saldoDevedorSolicitavel: '',
      limiteDisponivel: '',
      novaSolicitacaoLimite: '',
      valorPorCota: '',
      quantidadeCotas: 0,
      valorTotalProposta: '',
      saldoDevedorFuturo: ''
    }),
    computed: {
      ...mapState(['percentual_cotas_disponiveis_ativo', 'percentual_cotas_disponiveis', 'id_empresa']),
      limiteCotasComputed () {
        if (this.percentual_cotas_disponiveis_ativo) {
          return this.percentual_cotas_disponiveis * (this.limiteMaximoCotasGrupo / 100)
        }
        return this.limiteMaximoCotasGrupo
      },
      blockVoltarTela () {
        return (this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) || (this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) || (this.pedido.status_pedido === StatusPedido.PendenteAnaliseCredito)
      },
      limiteCotasLimitMessageComputed () {
        if ((this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) || (this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) || (this.pedido.status_pedido === StatusPedido.PendenteAnaliseCredito)) {
          return 'Ação proibida por conter análise de crédito.'
        }
        if (this.percentual_cotas_disponiveis_ativo) {
          return `Só é possível vender ${this.percentual_cotas_disponiveis}% das cotas disponíveis por vez.`
        }
        return 'Máximo de cotas atingido'
      },
      canRemoveCota () {
        return this.qtd_cotas > 1 && !this.pedido.carrinho.reserva_com_carrinho && !this.pedido.id_reserva && !(this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) && !(this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito)
      },
      canAddCota () {
        return !this.pedido.carrinho.reserva_com_carrinho && !this.pedido.id_reserva && !(this.pedido.status_pedido === StatusPedido.AprovadoAnaliseCredito) && !(this.pedido.status_pedido === StatusPedido.AguardandoDecisaoAnaliseCredito) && !(this.pedido.status_pedido === StatusPedido.PendenteAnaliseCredito)
      },
      valorTotal () {
        return (this.pedido.bem.valor_bem * this.qtd_cotas) || 0
      }
    },
    async mounted () {
      if (this.value && this.value.id_pedido) {
        await this.getPedido()
      } else {
        notification(AlertTypes.ERROR, 'Não foi possível buscar os dados da venda.')
      }
    },
    methods: {
      trimZeros,
      async getPedido (tries = 1) {
        try {
          // Otimização: usar minimal=1 para carregar apenas dados essenciais da tela Cotas
          const res = await this.$http.get(`/vendas/${this.value.id_pedido}?minimal=1`)
          res.data.beneficiario = { ...this.pedido.beneficiario, ...res.data.beneficiario }
          res.data.cliente_pedido = { ...this.pedido.cliente_pedido, ...res.data.cliente_pedido }
          res.data.cliente = { ...this.pedido.cliente, ...res.data.cliente }
          res.data.produto = { ...this.pedido.produto, ...res.data.produto }
          res.data.bem = { ...this.pedido.bem, ...res.data.bem }
          res.data.grupo = { ...this.pedido.grupo, ...res.data.grupo }
          res.data.plano = { ...this.pedido.plano, ...res.data.plano }
          res.data.analiseCredito = { ...this.pedido.plano, ...res.data.analiseCredito }

          this.pedido = { ...this.pedido, ...res.data }

          await this.buscarQuantidadeCotasDisponiveisGrupo(this.pedido.id_grupo || this.pedido.grupo.id_grupo)
          this.setCotas(this.pedido.carrinho.qt_cotas, this.pedido.id_reserva)
          this.$emit('input', { ...this.value, ...this.pedido })
        } catch (err) {
          if (tries < 3) {
            console.warn(`Tentativa ${tries} falhou: ${err}`)
            await this.getPedido(tries + 1)
          } else {
            console.error(err)
            notification(AlertTypes.ERROR, err, 'Não foi possível buscar os dados da venda. Tente novamente caso persistir entre em contato com a Área de Suporte!')
          }
        }
      },
      async verificarPossiveisBloqueios () {
        if (!this.limiteCreditoPontoVendaVerificado) {
          const limiteCreditoPontoVenda = await this.verificarLimiteCreditoPontoVenda()
          if (limiteCreditoPontoVenda.exibir_dialog === true) {
            this.limiteCreditoPontoVendaAtual = limiteCreditoPontoVenda.valor_atual
            this.limiteCreditoPontoVendaAumentar = limiteCreditoPontoVenda.valor_aumentar
            this.exibirDialogInformativoLimiteCreditoPontovendaExcedido = true
            this.limiteCreditoPontoVendaVerificado = true
            return false
          }
        }
        return this.continuarVerificacoes()
      },
      async continuarVerificacoes () {
        if (this.verificarQuantidadeCotas) {
          const quantidadeCotas = await this.verificarQuantidadeCotasDisponiveis()
          if (quantidadeCotas.exibir_dialog === true) {
            this.exibirDialogQuantidadeCotasDisponiveis = true
            this.bloquearBotaoProsseguir = true
            this.mensagemTooltipBotaoProsseguir = 'Quantidade de cotas ativas no grupo ultrapassada'
            this.cotasAtivasCliente = quantidadeCotas.cotas_ativas_cliente
            this.cotasAtivasGrupo = quantidadeCotas.cotas_ativas_grupo
            this.quantidadeCotasPermitidasVenda = quantidadeCotas.quantidade_cotas_permitidas_vendas
            this.dialogQuantidadeCotasAtivo = true
            return false
          }
        }

        const saldoDevedorCliente = await this.verificarSaldoDevedorCliente()
        if (saldoDevedorCliente.exibir_dialog === true) {
          this.limiteSaldoDevedorClienteAtual = saldoDevedorCliente.valor_atual
          this.limiteSaldoDevedorClienteAumentar = saldoDevedorCliente.valor_aumentar
          this.saldoDevedorCliente = saldoDevedorCliente.saldo_devedor_cliente
          this.pedido.saldo_para_aumentar = unmask(this.saldoDevedorCliente)
          this.saldoDevedorSolicitavel = saldoDevedorCliente.saldo_devedor_solicitavel
          this.limiteDisponivel = saldoDevedorCliente.limite_disponivel
          this.novaSolicitacaoLimite = saldoDevedorCliente.nova_solicitacao_limite
          this.valorPorCota = saldoDevedorCliente.valor_por_cota
          this.quantidadeCotas = saldoDevedorCliente.quantidade_cotas
          this.valorTotalProposta = saldoDevedorCliente.valor_total_proposta
          this.saldoDevedorFuturo = saldoDevedorCliente.saldo_devedor_futuro
          this.pedido.saldo_para_aumentar = unmask(this.saldoDevedorCliente)
          this.exibirDialogInformativoSaldoDevedorCliente = true
          return false
        }
        sendAnalyticsEvent(this.$gtag, 'cotas', {
          id_usuario: this.$session.get('id_usuario'),
          hierarquia: this.$session.get('hierarquia_comercial'),
          quantidade_cotas: this.qtd_cotas,
          bem: this.pedido.bem.nome_bem, // ou this.pedido.bem.cd_bem
          produto: this.pedido.produto.nome_produto,
          grupo: this.pedido.bem.cd_grupo, // ou this.pedido.grupo.nome
          cliente: {
            cpf_cnpj: this.pedido.cliente.pessoa === 'fisica' ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj) // CPF ou CNPJ
          }
        })
        return this.nextPage()
      },
      async verificarQuantidadeCotasDisponiveis () {
        try {
          const payload = {
            codigo_grupo: this.pedido.bem.cd_grupo,
            cpf_cnpj: this.pedido.cliente.pessoa === 'fisica' ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj),
            id_pedido: this.pedido.id_pedido,
            quantidade_cotas_pedidas: this.qtd_cotas
          }

          const cpfSegundaParte = this.definirCpfSegundaParte()

          if (cpfSegundaParte) {
            payload.cpf_segunda_parte = cpfSegundaParte
          }

          const result = await this.$http.post('/clientes/quantidade-cotas-disponiveis', payload)

          if (result.status === 200) {
            return result.data
          }
        } catch (error) {
          notification(AlertTypes.ERROR, 'Não foi possível verificar a quantidade de cotas disponíveis.')
        }
      },
      definirCpfSegundaParte () {
        if (this.pedido.cliente.pessoa === 'fisica' && (this.pedido.cliente.nome_conjuge !== '' || this.pedido.cliente.nome_conjuge !== null)) {
          return unmask(this.pedido.cliente.cpf_conjuge)
        }

        if (this.pedido.cliente.pessoa === 'juridica') {
          if (this.pedido.cliente.beneficiario) {
            return unmask(this.pedido.cliente.beneficiario.cpf)
          }
        }

        return false
      },
      async nextPage () {
        try {
          if (this.limiteSaldoDevedorClienteAumentar !== '') {
            await this.$http.post('/vendas', this.pedido)
          }
          await this.atualizaCarrinhoCompras(this.pedido.id_pedido, this.valorTotal, this.qtd_cotas)
          this.$emit('input', this.pedido)
          this.$emit('nextPage')
        } catch (error) {
          if (error.response && error.response.data) {
            const { Msg_Erro, Codigo_Erro } = error.response.data
            notification('error', Msg_Erro || 'Erro ao processar a solicitação. Tente novamente mais tarde.')
            console.error(`Erro ${Codigo_Erro}: ${Msg_Erro}`)
          } else {
            notification('error', 'Erro ao processar a solicitação. Tente novamente mais tarde.')
            console.error(error)
          }
        }
      },
      prevPage () {
        this.$emit('prevPage')
      },
      async buscarQuantidadeCotasDisponiveisGrupo (id_grupo) {
        return this.$http.get(`/grupos/quantidade_cotas_disponiveis/${id_grupo}`).then(({ data }) => {
          this.limiteMaximoCotasGrupo = data.qt_cotas
        }).catch(() => {
          this.errBuscarCotas = true
          notification(AlertTypes.WARN, 'Não foi possível consultar a quantidade de cotas disponíveis no Newcon.\nPortanto será limitado a uma cota.')
        })
      },
      setCotas (qt_cotas_banco, id_reserva) {
        if (!id_reserva && qt_cotas_banco && (qt_cotas_banco > this.limiteMaximoCotasGrupo)) {
          if (!this.errBuscarCotas) {
            notification(AlertTypes.WARN, 'As cotas selecionadas anteriormente ultrapassam a quantidade de cotas disponíveis atualmente no grupo, selecione novamente a quantidade desejada de cotas.')
          }
          this.qtd_cotas = 1
          return
        }
        qt_cotas_banco && (this.qtd_cotas = qt_cotas_banco)
      },
      async atualizaCarrinhoCompras (id_pedido, valor_total_compra, qt_cotas) {
        return this.$http.post('/carrinho/salvar-carrinho-pedido', { id_pedido, valor_total_compra, qt_cotas }).then((response) => {

        }).catch(err => {
          notification(AlertTypes.ERROR, err, 'Ocorreu um erro ao salvar as informações. Tente novamente ou entre em contato com a Área de Suporte.')
          throw err
        })
      },
      async verificarLimiteCreditoPontoVenda () {
        try {
          const resposta = await this.$http.post('/pontos-venda/limite-credito', {
            cpf_cnpj: this.pedido.cliente.pessoa === 'fisica' ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj),
            cd_ponto_venda: this.$session.get('cd_ponto_venda'),
            valor_contratado: this.definirValorContratado(this.valorTotal, this.pedido.grupo.taxa_adm),
            id_pedido: this.pedido.id_pedido
          })

          if (resposta.status === 200) {
            return resposta.data
          }
        } catch (error) {
          notification(AlertTypes.ERROR, 'Não foi possível verificar o limite de crédito do ponto venda!')
        }
      },
      async verificarSaldoDevedorCliente () {
        try {
          const resposta = await this.$http.post('/clientes/saldo-devedor', {
            cpf_cnpj: this.pedido.cliente.pessoa === 'fisica' ? unmask(this.pedido.cliente.cpf) : unmask(this.pedido.cliente.cnpj),
            valor_contratado: this.definirValorContratado(this.valorTotal, this.pedido.grupo.taxa_adm),
            id_pedido: this.pedido.id_pedido,
            valor_por_cota: this.pedido.bem.valor_bem,
            quantidade_cotas: this.qtd_cotas,
            id_empresa: this.id_empresa
          })

          if (resposta.status === 200) {
            return resposta.data
          }
        } catch (error) {
          this.nextPage()
        }
      },
      definirValorContratado (valorBem, taxaAdmin) {
        const newValorBem = valorBem / this.qtd_cotas
        const taxaAdminDecimal = (taxaAdmin) / 100
        const taxa = newValorBem * taxaAdminDecimal
        return (newValorBem + taxa) * this.qtd_cotas
      },
      fecharInformativoLimiteCreditoPontoVendaExcedido () {
        this.exibirDialogInformativoLimiteCreditoPontovendaExcedido = false
      },
      prosseguirInformativoLimiteCreditoPontoVendaExcedido () {
        this.exibirDialogInformativoLimiteCreditoPontovendaExcedido = false
        return this.continuarVerificacoes()
      },
      fecharInformativoSaldoDevedorCliente () {
        this.exibirDialogInformativoSaldoDevedorCliente = false
      },
      fecharProsseguirInformativoLimiteCreditoPontoVendaExcedido () {
        this.exibirDialogInformativoSaldoDevedorCliente = false
        return this.nextPage()
      },
      fecharInformativoQuantidadeCotasDisponiveis () {
        this.exibirDialogQuantidadeCotasDisponiveis = false
      },
      calcularLimiteQuantidadeCotasPodeComprar () {
        if (this.exibirDialogInformativoLimiteCreditoPontovendaExcedido === true) {
          const limiteCredito = parseFloat(
            this.limiteCreditoPontoVendaAtual.replace(/\./g, '').replace(',', '.')
          )

          const valorCotaFloat = parseFloat(this.pedido.bem.valor_bem)
          this.quantidadeCotasPodeComprar = Math.floor(limiteCredito / valorCotaFloat)

          if (this.quantidadeCotasPodeComprar > 1) {
            return `${this.quantidadeCotasPodeComprar} cotas`
          }

          return `${this.quantidadeCotasPodeComprar} cota`
        }

        if (this.dialogQuantidadeCotasAtivo === true) {
          if ((this.qtd_cotas + this.cotasAtivasCliente) > this.quantidadeCotasPermitidasVenda) {
            this.bloquearBotaoProsseguir = true
          } else {
            this.verificarQuantidadeCotas = false
            this.bloquearBotaoProsseguir = false
          }
          const quantidadeCotasPodeComprar = this.quantidadeCotasPermitidasVenda - this.cotasAtivasCliente
          if (quantidadeCotasPodeComprar <= 0) {
            return `0 cota`
          }
          if (quantidadeCotasPodeComprar > 1) {
            return `${quantidadeCotasPodeComprar} cotas`
          }

          return `${quantidadeCotasPodeComprar} cota`
        }
      }
    }
  }
</script>

<style scoped type="scss">
label {
    color: var(--darkgray);
    font-size: 1.2rem;
}

label+p,
label+span {
    font-size: 1.2rem;
    letter-spacing: 1px;
    font-weight: 400;
    color: var(--primary);
}

.codigo_grupo {
    padding: 5px 10px;
    background: var(--primary);
    color: #fff;
    border-radius: 5px;
    width: fit-content;
    font-size: 1.2rem;
    font-weight: 400;
}

.quantidade_cotas-label {
    font-size: 1.3rem;
    font-weight: 400;
    color: var(--advice_friendly);
}

.actions-background {
    position: relative;

    z-index: 0;
    /* Certifique-se de que o conteúdo esteja acima da camada de fundo */
}

.actions-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary);
    opacity: 0.15;
    z-index: -1;
    pointer-events: none;
}

.credito {
    font-size: 1.5rem;
    color: var(--primary);
    font-weight: 600;
}

.quantidade-cotas {
  margin-top: 28px;
  margin-left: 180px;
}

.warning-text {
    color: var(--primary);
    font-size: 12px;
    line-height: 1.5;
    text-align: center;
    width: 200px;
    word-wrap: break-word;
    margin: 0 auto;
  }
</style>
